import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import React from "react";
import { apiCall, makeApiMessage as MakeApiMessage } from "../../../components/src/common";
import { toString } from "lodash";
import { FormikValues } from "formik";
import moment from "moment";
import {
  checkForOrderPermissonStatus,
  CustomEnums,
  getCustomEnumName,
  customPermissionApiKey,
  OrderPermissionStatus,
  checkForAdvancedSearchPermissionStatus,
  AdvancedSearchPermissionStatus
} from "../../utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import { InvoiceRawData } from "../../print/src/PrintController";
import { IUserContext } from "../../../blocks/navigationmenu/src/HeaderController.web";
import { getStorageData } from "../../../../packages/framework/src/Utilities";

export interface IOption {
  label: string;
  value: string | number;
  disabled?: boolean;
}

export enum FieldType {
  dateRange,
  textbox,
  select,
  date,
}
export interface IFieldOptions {
  label: string;
  type: FieldType;
  filterKey: string;
  span?: boolean;
  isMulti?: boolean;
}

export interface OrderItems {
  attributes: {
    catalogue: {
      name: string;
      product_name: string;
      product_second_name: string;
    },
    quantity: number;
  }
}

export interface IPaid {
  amount: string;
  id: number;
  name: string;
  second_name: string;
  active: boolean;
  created_at: string;
  updated_at: string;
  name_translation: string;
  attributes: {
    icon: {
      data: {
        id: number;
        type: string;
        attributes: {
          id: number;
          name: string;
          second_name: string;
          image_type: string;
          name_translation: string;
          image: string;
        };
      };
    };
  };
}

export interface OrderTransactions {
  attributes: {
    payment_method: {
      name: string;
      created_at: string;
      payment_type:string
    }
  }
  payment_method:{
      name: string;
  }
}

export interface OrderResult {
  data: ISearchResult
}
export interface ISearchResult {
  id: string | number;
  type: string;
  attributes: {
    action_by_time_detail:{at:string,by:string}
    payment_received_by:string|null
    id: number;
    order_type: string;
    order_number: string;
    account_id: number;
    notes: string;
    sub_total: string;
    status: string;
    credit_note: boolean;
    credit_order_at: string;
    created_at: string;
    internal_status: string;
    cancelled_at: string;
    delivered_at: string;
    is_quick_drop: boolean;
    order_items: OrderItems[];
    total_items: number;
    total_pieces: number;
    paid_at: Date | null;
    customer: {
      id: number;
      full_phone_number: string;
      email: string;
      full_name: string;
      business: string | null;
      full_address: string;
      customer_profile: {
        street_address: string;
        business_label: string | null;
        customer_id: string | number;
      };
    };
    send_to_zatca?: boolean;
    order_transactions: OrderTransactions[];
    currency: string;
    total: string;
    store_name: string;
    applied_discount: string;
    cancellation_reason: string;
    tax_charges: string;
    shipping_charge: string;
    shipping_discount: string;
    shipping_total: string;
    total_tax: string;
    updated_at: string;
    save_for_future: boolean;
    promo_code_id: number;
    store_management_id: number;
    tax_included_in_product_price: boolean;
    address_id: string | null;
    is_mobile: boolean;
    adjustment_reason: string;
    adjustment_note: string;
    refund_amount: string;
    rewash_order: boolean;
    customer_complaint: string | null;
    parent_order_id: string | null;
    adjustment_request: string | null;
    adjustment_order: boolean;
    tax_percentage: string;
    driver_account_id: string | null;
    driver_action: string | null;
    driver_action_at: string | null;
    driver_confirmed_at: string | null;
    driver_order_changes: string | null;
    pickup_date: string | null;
    delivery_date: string | null;
    status_plant: string;
    placed_at: string,
    invoice_receipt_pdf_url: string;
    credit_note_receipt: string;
    split_order_by: string | null,
    delivery_address: string | null,
    order_created_by: {
      id: number;
      first_name: string;
      last_name: string;
      full_name: string;
    },
    promo_code: {
      saved_amount: string;
      discount: string;
      expiry_date: string |null,
      min_order_amount: string;
      promo_expires: boolean;
      promo_code: string;
      description: string;
      id: number;
      currency: string;
      max_discount: string;
    },
    store_second_name: string | null,
    name_translation: string;
    no_of_items: number;
    no_of_pieces: number;
    store_management: {
      data: {
        id: string;
        type: string;
        attributes: {
          id: number;
          store_name: string;
          name_translation: string;
          use_raw_printing_receipt?: boolean;
        }
      }
    },
    invoice_pdf_url: string | null,
    total_upcharge_amount: string;
    driver_account: string | null,
    price_list_name: string;
  };
  raw_print_data?: InvoiceRawData;
}

export interface ISearchResultData {
  data: ISearchResult[];
  meta: {
    total_pages: number;
    total_count: number;
    current_page: number;
    next_page: number | null;
    previous_page: number | null;
  };
  message?:string
}

export interface IFilterData {
  name?: string;
  mobile_number?: string;
  email?: string;
  address?: string;
  customer_id?: string;
  business?: string;
  payment?: string;
  payment_type?: number;
  paid?: string;
  specific_date?: string;
  order_id?: string;
  notes?: string;
  placed?: string;
  store?: Array<string | number>;
  paid_date_range?: [string, string];
  placed_date_range?: [string, string];
}

export interface ISearchResultList {
  openOrderDetails: Function;
  searchResultList: ISearchResult[];
  totalCount: number;
  currentPage: number;
  rowPerPage: number;
  onChangePage: Function;
  isDrawerOpen: boolean;
  tabId: number;
  handleTabChange: Function;
  handleMomentDateFormat: Function;
  onPrintReceipt: (searchResultItem: ISearchResult) => void
  showPaymentModal?: Function;
  toggleCreditNoteDialog: Function;
  permissionStatus: OrderPermissionStatus;
}

export interface IBusinessData {
  data: IBusiness[];
}

export interface ICityData {
  cities: ICity[];
}

export interface ICity {
  id: number;
  name: string;
  name_ar: string;
  name_en: string;
}

interface IBusiness {
  id: string;
  type: string;
  attributes: {
    id: number;
    label: string;
    module_name: string;
    created_at: string;
    updated_at: string;
    model_name: string;
  };
}

interface IStore {
  id: string;
  type: string;
  attributes: {
    id: number;
    store_name: string;
  };
}

interface IStoreData {
  data: Array<IStore>;
}

interface IconAttributes {
  id: number;
  name: string;
  second_name: string;
  image_type: string;
  name_translation: string;
  image: string;
}

interface IconData {
  id: number;
  type: string;
  attributes: IconAttributes;
}

interface PaymentMethodAttributes {
  id: number;
  name: string;
  second_name: string;
  active: boolean;
  created_at: string;
  updated_at: string;
  name_translation: string;
  attributes: {
    icon: {
      data: IconData;
    };
  };
}

export interface StoreManagementDropdownResponse {
  data: any;
  id: number;
  store_name: string;
}

interface PaymentMethod {
  id: number;
  name: string;
  second_name: string;
  active: boolean;
  created_at: string;
  updated_at: string;
  name_translation: string;
  attributes: PaymentMethodAttributes;
}

interface PaymentMethodResp {
  status: number;
  data: PaymentMethod[];
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  //isDrawerOpen: boolean;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  token: string;
  orderData: ISearchResult | never | null;
  firstNameSearchText: string;
  lastNameSearchText: string;
  advancedsearchList: any;
  activeId: number;
  activeFirstName: string;
  activeLastName: string;
  activeUserName: string;
  activeEmail: string;
  activePhoneNumber: string;
  activeCountryCode: string;
  activeType: string;
  activeDeviceId: string;
  activeCreatedAt: string;
  isVisible: boolean;
  selectedSearchType: string;
  selectedOrderType: string;
  allPaymentMethod: IOption[];
  allStoreList: IOption[];
  allBusinessList: IOption[];
  allCitiesList: IOption[];
  searchResultList: ISearchResult[];
  totalCount: number;
  totalSearchedResult: number | null;
  filterValues: IFilterData;
  tabId: number;
  isDrawerOpen: boolean;
  showPaymentPopup: boolean;
  selectedOrder: ISearchResult | never | null;
  paymentClicked: boolean;
  customerId: string;
  receiptPrinterSetting: any;
  errorMessage: string;
  creditNoteOrder?: ISearchResult;
  creditNotePresent?: boolean;
  isCreditNoteDialogOpen: boolean;
  creditNoteReceipt: string;
  hidden: boolean;
  addNote: string;
  isConfirmationChecked: boolean;
  creditLoader: boolean;
  openCrediNoteModalLoader: boolean;
  creditNoteOrderNumber: number | null | string;
  snackbarMessage: string;
  snackbarOpen: boolean;
  snackbarServerity: 'success' | 'error';
  permissionStatus: OrderPermissionStatus;
  advancedSearchPermissionStatus: AdvancedSearchPermissionStatus | null;
  isLoading: boolean;
  isB2bActive: boolean
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class AdvancedSearchController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  advancedsearchApiCallId: string = "";

  commonFields = [
    {
      filterKey: "name",
      label: "Name",
      type: FieldType.textbox,
    },
    {
      filterKey: "mobile_number",
      label: "Mobile No",
      type: FieldType.textbox,
    },
    {
      filterKey: "email",
      label: "Email",
      type: FieldType.textbox,
    },
    {
      filterKey: "address",
      label: "Address",
      type: FieldType.textbox,
    },
    {
      filterKey: "customer_id",
      label: "Customer ID",
      type: FieldType.textbox,
    },
  ];

  customerFields: Array<IFieldOptions> = [
    ...this.commonFields,
    {
      filterKey: "city_id",
      label: "City",
      type: FieldType.select,
    },
    {
      filterKey: "business",
      label: "Business",
      type: FieldType.select,
    },
  ];
  b2bFields: Array<IFieldOptions> = [
    {
      filterKey: "name",
      type: FieldType.textbox,
      label: "Name",
    },
    {
      filterKey: "mobile_number",
      type: FieldType.textbox,
      label: "Mobile No",
    },
    {
      filterKey: "email",
      label: "Email",
      type: FieldType.textbox,
    },
    {
      filterKey: "address",
      type: FieldType.textbox,
      label: "Address",
    },
    {
      filterKey: "employee_id",
      type: FieldType.textbox,
      label: "Employee Id",
    },
    {
      filterKey: "business_account_name",
      type: FieldType.textbox,
      label: "Business Account Name",
    },
    {
      filterKey: "company_name",
      type: FieldType.textbox,
      label: "Company Name",
    },
    {
      filterKey: "order_id",
      type: FieldType.textbox,
      label: "Order ID",
    },
    {
      filterKey: "notes",
      type: FieldType.textbox,
      label: "Notes",
    },
    {
      filterKey: "placed_date_range",
      type: FieldType.dateRange,
      label: "Placed - Date Range",
    },
  ];
  orderFields: Array<IFieldOptions> = [
    ...this.commonFields,
    {
      filterKey: "business",
      label: "Business",
      type: FieldType.select,
    },
    {
      filterKey: "payment",
      label: "Payment",
      type: FieldType.select,
    },
    {
      filterKey: "payment_type",
      label: "Payment Types",
      type: FieldType.select,
    },
    {
      filterKey: "paid",
      label: "Paid",
      type: FieldType.select,
    },
      {
      filterKey: "store",
      label: "Store",
      type: FieldType.select,
      isMulti: true,
    },
    {
      filterKey: "paid_date_range",
      label: "Paid - Date Range",
      type: FieldType.dateRange,
      span: true,
    },
    {
      filterKey: "order_id",
      label: "Order ID",
      type: FieldType.textbox,
    },
    {
      filterKey: "notes",
      label: "Notes",
      type: FieldType.textbox,
    },
    {
      filterKey: "placed",
      label: "Placed",
      type: FieldType.select,
    },
    {
      filterKey: "order_types",
      label: "Order",
      type: FieldType.select,
    },
    {
      filterKey: "placed_date_range",
      label: "Placed - Date Range",
      type: FieldType.dateRange,
      span: true,
    },
  ];

  currentPage: number = 1;
  rowPerPage: number = 10;
  searchOrderApiCallID: string = "";
  getAllPaymentMethodApiCallID: string = "";
  getAllBusinessListApiCallID: string = "";
  getAllCitiesListApiCallID: string = "";
  getOrderMessageId: string = "";
  getRawOrderInvoiceDataCallId: string = "";
  getRawGoldenPointOrderInvoiceCallId: string = "";
  generateOrderInvoiceCallId: string = "";
  getCreateCreditNoteMessageId: string = "";
  getCreditNoteMessageId: string = "";
  getAllStoreApiCallID: string = "";

  // Customizable Area End
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.LayoutDataMessage),
      getName(MessageEnum.PrintSettingsMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      token: "",
      orderData: null,
      firstNameSearchText: "",
      lastNameSearchText: "",
      advancedsearchList: [],
      activeId: 0,
      activeFirstName: "",
      activeLastName: "",
      activeUserName: "",
      activeEmail: "",
      activePhoneNumber: "",
      activeCountryCode: "",
      activeType: "",
      activeDeviceId: "",
      activeCreatedAt: "",
      isVisible: false,
      selectedSearchType: "Orders",
      selectedOrderType: "All Orders",
      allPaymentMethod: [],
      allStoreList: [],
      allBusinessList: [],
      allCitiesList: [],
      searchResultList: [],
      totalCount: 10,
      totalSearchedResult: null,
      filterValues: {},
      tabId: 0,
      isDrawerOpen: localStorage.getItem("isPinned") == "true",
      showPaymentPopup: false,
      selectedOrder: null,
      paymentClicked: false,
      customerId: '',
      receiptPrinterSetting: '',
      errorMessage: "",
      creditNoteReceipt: "",
      hidden: true,
      isCreditNoteDialogOpen: false,
      creditNoteOrder: undefined,
      creditNotePresent: false,
      addNote: "",
      creditLoader: false,
      isConfirmationChecked: true,
      openCrediNoteModalLoader: false,
      creditNoteOrderNumber: null,
      snackbarMessage: '',
      snackbarOpen: false,
      snackbarServerity: 'success',
      permissionStatus: {
        mainPermission: false,
        createOrderPermission: false,
        viewOrderPermission: false,
        cleanAction: false,
        sendToDriverAction: false,
        editOrderPermission: false,
        sendToDeadStockAction: false,
        storeDropdownAction: false,
        rewashAction: false,
        cleaningDropdownAction: false,
        zatcaLogsAccess: false,
        readyDropdownAction: false,
        viewCreditOrderAccess: false,
        createCreditNoteAccess: false,
        comingToStoreAccess: false,
        comingToStoreAllAccess: false,
        changeDriverAccess: false
      },
      advancedSearchPermissionStatus: null,
      isLoading: false,
      isB2bActive:false
      // Customizable Area End
    };
    // Customizable Area Start
    this.showPaymentModal = this.showPaymentModal.bind(this)
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    super.componentDidMount();
    const isB2b = await getStorageData("accountType")
    this.setState({isB2bActive: isB2b === "b2b" ? true : false})
    this.getToken();
    if (this.isPlatformWeb() === false) {
      this.props.navigation.addListener("willFocus", () => {
        this.getToken();
      });
    }
    // Customizable Area Start
    this.getAllPaymentMethod();
    this.getAllBusinessList();
    this.getAllStores();
    // Customizable Area End
  }

  getToken = () => {
    const msg: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(msg);
  };

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.receiveDataFromLayout(message);
    this.receivePrintSettings(message);
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      switch (apiRequestCallId) {
        case this.getAllPaymentMethodApiCallID:
          this.handlePaymentAllMethodResponse(responseJson);
          break;
        case this.getAllBusinessListApiCallID:
          this.handleBusinessListResponse(responseJson);
          break;
        case this.getAllCitiesListApiCallID:
          this.handleCitiesListResponse(responseJson);
          break;
        case this.searchOrderApiCallID:
          this.handleSearchApiListResponse(responseJson);
          break;
        case this.getOrderMessageId:
          this.handleGetOrderResponse(responseJson)
          break;
        case this.getRawOrderInvoiceDataCallId:
          this.handleRawInvoiceDataResponse(responseJson)
          break;
        case this.getRawGoldenPointOrderInvoiceCallId:
          this.handleRawInvoiceDataResponse(responseJson)
          break;
        case this.generateOrderInvoiceCallId:
          this.handleReGenerateInvoiceResponse(responseJson)
          break;
        case this.getCreditNoteMessageId:
          this.handleGetCreditNoteResponse(responseJson)
          break;
        case this.getCreateCreditNoteMessageId:
          this.handleCreateCreditNoteResponse(responseJson)
          break;
        case this.getAllStoreApiCallID:
          this.handleStoreAllMethodResponse(responseJson)
          break;
        default:
          break;
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  receivePrintSettings = (message: Message) => {
    if (message.id === getName(MessageEnum.PrintSettingsMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.PrintSettngsData)
        );
        if (recievedData) {
            this.setState({ receiptPrinterSetting: recievedData.receiptPrinterSetting})
        }
    }
  }
  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.LayoutMessageData)
        );
        if (recievedData.userContext) {
          this.setState({ isDrawerOpen: recievedData.isDrawerOpen});
          this.handleUserChange(recievedData.userContext);
      }
    }
  }

 

  renderOptionValues(
    item: string,
    options: Array<IOption>,
    placeholder: string
  ) {
    let labelToDisplay: string | React.ReactNode = "";
    if (Array.isArray(options)) {
      let option = options.find((node) => node.value === item);
      labelToDisplay =
        option && option.value ? (
          option.label
        ) : (
          <span style={{ color: "#4D4D4D" }}>{placeholder}</span>
        );
    }
    return labelToDisplay;
  }

  getAllPaymentMethod() {
    let paymentApiUrl = `${configJSON.getAllPaymentMethodEndPoint}?dropdown=true`;
    let headers = {
      token: localStorage.getItem("token"),
    };
    const getAllPaymentAllMsg = apiCall({
      httpBody: {},
      header: headers,
      url: paymentApiUrl,
      httpMethod: "GET",
    });
    this.getAllPaymentMethodApiCallID = getAllPaymentAllMsg.messageId;
    runEngine.sendMessage(getAllPaymentAllMsg.id, getAllPaymentAllMsg);
  }

    getAllStores() {
    let storeApiUrl = `${configJSON.getAllStoresListEndPoint}`;
    let headers = {
      token: localStorage.getItem("token"),
    };
    const getAllStoreAllMsg = apiCall({
      httpBody: {},
      header: headers,
      url: storeApiUrl,
      httpMethod: "GET",
    });
    
    this.getAllStoreApiCallID = getAllStoreAllMsg.messageId;
    runEngine.sendMessage(getAllStoreAllMsg.id, getAllStoreAllMsg);
  }

  getAllBusinessList() {
    let businessApiUrl = `${configJSON.getAllBusinessListEndPoint}`;
    let headers = {
      token: localStorage.getItem("token"),
    };
    const getAllBusinessListMsg = apiCall({
      httpBody: {},
      header: headers,
      url: businessApiUrl,
      httpMethod: "GET",
    });
    this.getAllBusinessListApiCallID = getAllBusinessListMsg.messageId;
    runEngine.sendMessage(getAllBusinessListMsg.id, getAllBusinessListMsg);
  }

  getAllCitiesList() {
    let citiesApiUrl = `${configJSON.getCitiesListEndPoint}`;

    const getAllCityListMsg = apiCall({
      httpBody: {},
      header: {},
      url: citiesApiUrl,
      httpMethod: "GET",
    });

    this.getAllCitiesListApiCallID = getAllCityListMsg.messageId;
    runEngine.sendMessage(getAllCityListMsg.id, getAllCityListMsg);
  }

  handlePaymentAllMethodResponse(responseJson: PaymentMethodResp) {
    let newArray = responseJson.data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      };
    });
    this.setState({ allPaymentMethod: newArray });
  }

  handleStoreAllMethodResponse(responseJson: StoreManagementDropdownResponse) {
    let newArray = responseJson.data.map((item: { attributes: { id: any; store_name: any; }; }) => {
      return {
        value: item.attributes.id,
        label: item.attributes.store_name,
      };
    });

    this.setState({ allStoreList: newArray });
  }

  handleBusinessListResponse(responseJson: IBusinessData) {
    let newArray = responseJson.data.map((item: IBusiness) => {
      return {
        value: item.id,
        label: item.attributes.label,
      };
    });
    this.setState({ allBusinessList: newArray });
  }

  handleCitiesListResponse(responseJson: ICityData) {
    let newArray = responseJson.cities.map((item: ICity) => {
      return {
        value: item.id,
        label: item.name,
      };
    });
    this.setState({ allCitiesList: newArray });
  }

  handleSearchApiListResponse(responseJson: ISearchResultData ) {
    const { data, meta } = responseJson;
    if(!data && !meta){
      this.setState({
        isLoading:false,
        snackbarOpen: true,
        snackbarMessage: responseJson.message ? responseJson.message :'',
        snackbarServerity: "error",
      })
    }
    else 
    {
      this.setState({
        searchResultList: data,
        totalCount: meta.total_count,
        totalSearchedResult: meta.total_count,
        isLoading:false
      });
    }
   
    this.currentPage = meta.current_page;
  }

getOptions(stringkey: string): IOption[] {
  const { allPaymentMethod, allBusinessList, allCitiesList, allStoreList } = this.state;

  switch (stringkey) {
    case "payment_type":
      return allPaymentMethod as IOption[];
       case "store":
      return allStoreList as IOption[];
    case "paid":
    case "placed":
      return [
        { label: "After", value: "After" },
        { label: "Before", value: "Before" },
      ];

    case "order_types":
      return [
        { label: "Order", value: "Order" },
        { label: "Redeem Order", value: "Redeem Order" },
        { label: "Credit Note", value: "Credit Note" },
        { label: "Advance Sales", value: "Advance Sales" },
        { label: "Rewash Order", value: "Rewash Order" },
      ];

    case "all_orders":
      return [
        { label: "All Orders", value: "all" },
        { label: "Awaiting Clean", value: "cleaning" },
        { label: "Awaiting Collection", value: "ready" },
        { label: "Deadstock", value: "send_to_deadstock" },
      ];

    default:
      return [];
  }
}


  isDateFieldDisable(filterKey: string, values: FormikValues) {
    if (filterKey === "paid_date") return !values["paid"];
    else if (filterKey === "placed_date") return !values["placed"];
    else return false;
  }  

  handelDateRangeChange(
    filterKey: string,
    setFieldValue: Function,
    value?: any
  ) {
    value && setFieldValue(filterKey, value);
    if (["paid_date", "paid"].includes(filterKey)) {
      setFieldValue("paid_date_range", "");
    } else if (["placed_date", "placed"].includes(filterKey)) {
      setFieldValue("placed_date_range", "");
    } else if (filterKey === "paid_date_range") {
      setFieldValue("paid", "");
      setFieldValue("paid_date", "");
    } else if (filterKey === "placed_date_range") {
      setFieldValue("placed", "");
      setFieldValue("placed_date", "");
    }
  }

  onChangeStatus(value:string) {
    this.setState({
      selectedOrderType: value,
      totalSearchedResult: null,
      searchResultList: [],
    });
  }

  handleSearchApiCall(values: FormikValues) {
    this.setState({ isLoading: true });
    const { selectedOrderType, selectedSearchType } = this.state;
    this.setState({ filterValues: values });
    const tabId = this.orderTypeReturn();
    const filterList = Object.keys(values).filter((item) => values[item]);
    let orderStatus = this.getOptions("all_orders")?.filter((item) => {
      return item.label == selectedOrderType;
    })[0].value;

    const allRecords = orderStatus === "all";
    let statusKey =
      selectedSearchType === "Orders" && !allRecords
        ? `status=${orderStatus}&`
        : "";

    let urlString = filterList.map((item) => {
      if (item == "paid_date") {
        return `paid[date]=${moment(values[item]).format("YYYY-MM-DD")}`;
      } else if (item == "placed_date") {
        return `placed[date]=${moment(values[item]).format("YYYY-MM-DD")}`;
      } else if (item == "paid_date_range") {
        return `paid_date_range[from]=${moment(values[item][0]).format(
          "YYYY-MM-DD"
        )}&paid_date_range[to]=${moment(values[item][1]).format("YYYY-MM-DD")}`;
      } else if (item == "placed_date_range") {
        return `placed_date_range[from]=${moment(values[item][0]).format(
          "YYYY-MM-DD"
        )}&placed_date_range[to]=${moment(values[item][1]).format(
          "YYYY-MM-DD"
        )}`;
      } else if (item == "placed") {
        return `placed[value]=${values[item]}`;
      } else if (item == "paid") {
        return `paid[value]=${values[item]}`;
      }else if (item == "order_types") {
        const orderTypeValue = values[item] || "Order";
        return `order_types=${encodeURIComponent(orderTypeValue)}`;
      }
       else {
        return `${item}=${encodeURIComponent(values[item])}`;
      }
    });

    let searchTypeParam =
    selectedSearchType === "Customers"
      ? "Customers"
      : "Orders";
    // let searchApiurl = `${configJSON.searchOrderApiEndPoint}?page_no=${
    //   this.currentPage
    // }&per_page=${this.rowPerPage}&${statusKey}${urlString.join("&")}&order_type=${tabId}`;
    let searchApiurl = `${configJSON.searchOrderApiEndPoint}?page_no=${
    this.currentPage
    }&per_page=${this.rowPerPage}&${statusKey}${urlString.join("&")}&order_type=${tabId}&search_type=${searchTypeParam}`;
    let headers = {
      token: localStorage.getItem("token"),
    };

    if(this.state.isB2bActive){
      searchApiurl = searchApiurl + `&request_type=B2bOrder`
    }

    const getSearchResultMsg = apiCall({
      httpBody: {},
      header: headers,
      url: searchApiurl,
      httpMethod: "GET",
    });

    this.searchOrderApiCallID = getSearchResultMsg.messageId;
    runEngine.sendMessage(getSearchResultMsg.id, getSearchResultMsg);
  }

  onChangePage(page: number) {
    this.currentPage = page;
    this.handleSearchApiCall(this.state.filterValues);
  }

  onChangeSearchType(value: string) {
    this.setState({
      selectedSearchType: value,
      totalSearchedResult: null,
      searchResultList: [],
      tabId: 0
    });
    value === 'Customers' && this.state.allCitiesList.length === 0 && this.getAllCitiesList();
  }

  onResetForm(callback?: Function) {
    this.setState({
      searchResultList: [],
      totalSearchedResult: null,
      selectedSearchType: "Orders",
      selectedOrderType: "All Orders",
      tabId: 0
    });
    callback && callback();
  }

  getDynamicFieldArray(isOrder: boolean): Array<IFieldOptions> {
    return isOrder ? this.orderFields : this.customerFields;
  }
  getDynamicInitialValues(fields: Array<IFieldOptions>) {
    return fields.reduce((accval, current) => {
      return {
        ...accval,
        [current.filterKey]: current.filterKey === "store" ? [] : ""
      };
    }, {});
  }

  setModal = (item: any) => {
    this.setState({
      activeId: item.id,
      activeFirstName: item.attributes.first_name,
      activeLastName: item.attributes.last_name,
      activeUserName: item.attributes.user_name,
      activeEmail: item.attributes.email,
      activePhoneNumber: item.attributes.phone_number,
      activeCountryCode: item.attributes.country_code,
      activeType: item.type,
      activeDeviceId: item.attributes.device_id,
      activeCreatedAt: item.attributes.created_at,
      isVisible: !this.state.isVisible,
    });
  };

  closeOrderDetails() {
    this.setState({ orderData: null });
  }

  openOrderDetails(data: ISearchResult) {
    this.setState({ orderData: data });
  }

  getAdvancedSearchList = (token: string) => {
    if (
      this.state.firstNameSearchText.length === 0 &&
      this.state.lastNameSearchText.length === 0
    ) {
      return;
    }

    const header = {
      "Content-Type": configJSON.advancedsearchApiContentType,
      token: token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    let attrs = null;

    if (
      this.state.firstNameSearchText.length > 0 &&
      this.state.lastNameSearchText.length > 0
    ) {
      attrs = {
        first_name: this.state.firstNameSearchText,
        last_name: this.state.lastNameSearchText,
      };
    } else if (this.state.firstNameSearchText.length > 0) {
      attrs = {
        first_name: this.state.firstNameSearchText,
      };
    } else if (this.state.lastNameSearchText.length > 0) {
      attrs = {
        last_name: this.state.lastNameSearchText,
      };
    }

    this.advancedsearchApiCallId = requestMessage.messageId;

    
    let urlParams = new URLSearchParams(attrs as Record<string, string>).toString();

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getAdvancedSearchApiEndPoint}?${urlParams}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  setFirstNameText = (firstName: string) => {
    this.setState({ firstNameSearchText: firstName });
  };

  setLastNameText = (firstName: string) => {
    this.setState({ lastNameSearchText: firstName });
  };

  hideModal = () => {
    this.setState({ isVisible: !this.state.isVisible });
  };

  txtInputFirstNameSearchTextProps = {
    onChangeText: (text: string) => {
      this.setFirstNameText(text);
    },
  };

  txtInputLastNameSearchTextProps = {
    onChangeText: (text: string) => {
      this.setLastNameText(text);
    },
  };

  orderTypeReturn = () => {
    const { tabId } = this.state;
    switch(tabId) {
      case 0:
        return "store_order";
      case 1:
        return "home_cleaning";
    }
  }

  handleTabChange = (valNum: number) => {
    const { filterValues } = this.state;
    this.setState({ 
      tabId: valNum
    }, () => this.handleSearchApiCall(filterValues));
  };

  handleOpenChanged = (open: boolean) => {
    this.setState({ 
      isDrawerOpen: open 
    })
  };

  handleMomentDateFormat(date: string, dateFormat: string) {
    const formatedDate = moment(date).format(dateFormat);
    return formatedDate;
  }

  handleOrderMomentDateFormat(date: string, dateFormat: string) {
    const formatedDate = moment.parseZone(date).format(dateFormat);
    return formatedDate;
  }

  showPaymentModal(order: ISearchResult) {
    this.setState({
      showPaymentPopup: !this.state.showPaymentPopup,
      selectedOrder: order
    })
  }

  handlePaymentDone = () => {
    this.setState({ paymentClicked: true });
    this.getOrder();
  };

  getOrder() {
    let order = this.state.selectedOrder;
    this.setState({ customerId: String(order?.attributes.account_id) });

    let message = MakeApiMessage({
      method: "GET",
      url: configJSON.getOrderApi + order?.id,
    });
    this.getOrderMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  handleGetOrderResponse(
    response: OrderResult
  ) {
      if (response.data) {
        this.setState({ selectedOrder: response.data });
        if (this.state.paymentClicked) {
          this.setState(
            {
              showPaymentPopup: false,
              paymentClicked: false,
              selectedOrder: null
            },
            () => { this.handleSearchApiCall(this.state.filterValues) }
          );
        }
      }
  }

  handlePaymentModalClose = () => {
    this.setState({ showPaymentPopup: false });
  };

  formatTaxPercentage = () => {
    const { selectedOrder } = this.state;

    if (!selectedOrder) return null;
    const decimalIndex = selectedOrder.attributes.tax_percentage.indexOf(".");
    const formattedTaxPercentage =
    selectedOrder.attributes.tax_percentage.slice(0, decimalIndex) + "%";
    return formattedTaxPercentage;
  };

  convertToOptionObj(options: IOption[],idProperty: keyof IOption) {
    return options.map(option => ({
      id: String(option[idProperty]),
      option: String(option.label),
      disabled: option.disabled || false
    }));
  }

  handleCloseSnackbar = () => this.setState({ errorMessage: "" })

  sendPrintMessage = (payload: unknown, isRawPrint?: boolean) => {
    const action = isRawPrint ? "PRINT_RECEIPT" : "PRINT_FILE"
    const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), action)
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), payload)
    this.send(printMessage)
  }


  handlePrintReceipt = (searchResultItem: ISearchResult) => {
    const {raw_print_data, attributes, id} = searchResultItem
    const orderId = toString(id)
    const {store_management, invoice_receipt_pdf_url} = attributes
    if (store_management?.data?.attributes?.use_raw_printing_receipt) {
      this.handleReceiptRawPrinting(orderId, raw_print_data)
      return;
    }
    if (invoice_receipt_pdf_url) {
      this.sendPrintMessage({
        format: "pdf",
        data: invoice_receipt_pdf_url
      })
    } else {
      this.handleReGenerateOrderInvoice(orderId)
    }
  }

  handleReceiptRawPrinting = (orderId: string, rawPrintData?: InvoiceRawData) => {
    if (rawPrintData) {
      this.sendPrintMessage(rawPrintData, true)
    } else {
      const order = this.state.searchResultList.find(
      item => item.id === orderId
    );
    if (order?.type === "advance_sales_golden_point") {
      this.getGoldenPoinrRawInvoiceData(orderId);
      } else {
        this.getRawInvoiceData(orderId);
      }
    }
  }

  getRawInvoiceData = (orderId: string) => {
    const apiMessage = MakeApiMessage({
      method: "GET",
      url: configJSON.rawOrderInvoiceData + orderId
    })
    this.getRawOrderInvoiceDataCallId = apiMessage.messageId
    this.send(apiMessage)
  }

  getGoldenPoinrRawInvoiceData = (orderId: string) => {
    const apiMessage = MakeApiMessage({
      method: "GET",
      url: configJSON.rawGoldenPointOrderInvoiceData + orderId
    })
    this.getRawGoldenPointOrderInvoiceCallId = apiMessage.messageId
    this.send(apiMessage)
  }

  handleRawInvoiceDataResponse = (response?: {data?: InvoiceRawData} ) => {
    if (response?.data) {
      this.setState((prev) => ({
        searchResultList: prev.searchResultList.map(searchResult => searchResult.id == toString(response.data?.order.order_id) ? (
          {
            ...searchResult,
            raw_print_data: response.data
          }): searchResult)
        })
      )
      this.sendPrintMessage(response.data, true)
    } else {
      this.setState({errorMessage: "Unable to fetch raw order data"})
    }
  }

  handleReGenerateOrderInvoice = (order_id: string) => {
    let message = MakeApiMessage({
      url: configJSON.generateOrderInvoiceEndPoint + order_id,
      method: "GET",
    });
    this.generateOrderInvoiceCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleReGenerateInvoiceResponse = (response: { status: number; invoice_receipt_pdf_url: string; order_id: number}) => {
    if (response.invoice_receipt_pdf_url) {
      this.setState((prev) => ({
        searchResultList: prev.searchResultList.map(searchResult => searchResult.id === toString(response.order_id) ? (
          {
            ...searchResult,
            attributes: {
              ...searchResult.attributes,
              invoice_receipt_pdf_url: response.invoice_receipt_pdf_url
            }
          }): searchResult)
        })
      )
      this.sendPrintMessage({
        format: "pdf",
        data: response.invoice_receipt_pdf_url
      });
    } else {
      this.setState({ errorMessage: "Unable to fetch receipt for this order" });
    }
  };

  renderCreditOrderNumber = (orderNumber: string | undefined) => {
    const {
      hidden,
      creditNoteOrderNumber,
      openCrediNoteModalLoader
    } = this.state;

    if(openCrediNoteModalLoader) {
      return "";
    } else {
      if(!hidden) {
        return orderNumber;
      } else {
        return creditNoteOrderNumber;
      };
    };
  };

  handleAddNote = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ addNote: event.target.value });
  };

  hanldeClickPrintCreditNote = () => {
    const { creditNoteReceipt } = this.state;

    const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
      printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "PRINT_FILE")
      printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), {
        format: "pdf",
        data: creditNoteReceipt
      })
      this.send(printMessage)
  };

  handleConfirmationCheckBox = () => {
    if (!this.state.creditNotePresent)
      this.setState({
        isConfirmationChecked: !this.state.isConfirmationChecked,
      });
  };

  toggleCreditNoteDialog = (item?: ISearchResult) => {
    this.setState({
      isCreditNoteDialogOpen: !this.state.isCreditNoteDialogOpen,
      creditNotePresent: false,
      creditNoteOrder: item,
      creditNoteReceipt: "",
      hidden: true,
    });
    item && this.getCreditNoteDetailApi(String(item.id));
  };

  getCreditNoteDetailApi(orderId?: string) {
    this.setState({ openCrediNoteModalLoader: true });

    const message = MakeApiMessage({
      url: configJSON.getCreditNoteEndpoint + orderId,
      method: "GET",
    });
    this.getCreditNoteMessageId = message.messageId;
    this.send(message);
  }

  createCreditNoteApiCall = () => {
    const { addNote, creditNoteOrder } = this.state;

    this.setState({ creditLoader: true });

    const message = MakeApiMessage({
      url: configJSON.createCreditNoteEndPoint,
      method: "POST",
      body: JSON.stringify({
        notes: addNote,
        order_id: creditNoteOrder?.id,
      }),
    });
    this.getCreateCreditNoteMessageId = message.messageId;
    this.send(message);
  };

  handleGetCreditNoteResponse = (response: {
    data: ISearchResult,
    errors: string
  }) => {
    if(response.data) {
      const note = response.data.attributes?.notes || "";
      this.setState({
        addNote: note,
        creditNotePresent: true,
        creditNoteOrderNumber: response.data.attributes.order_number,
        creditNoteReceipt:  toString(response.data.attributes.credit_note_receipt),
        openCrediNoteModalLoader: false
      });
    } else if (response?.errors) {
      this.setState({ hidden: false, openCrediNoteModalLoader: false });
    } else {
      console.debug(response);
    }
  };

  handleCreateCreditNoteResponse = (response: {
    errors: string;
    message: string;
  }) => {
    if(response?.errors?.length) {
      this.setState({
        creditLoader: false,
        snackbarOpen: true,
        snackbarMessage: response.errors,
        snackbarServerity: "error",
      });
    } else {
      this.setState({
        snackbarOpen: true,
        snackbarServerity: "success",
        snackbarMessage: response.message,
        creditLoader:false,
        creditNoteOrder: undefined,
        isCreditNoteDialogOpen: false,
      });
      this.handleSearchApiCall(this.state.filterValues);
    }
  };

  handleCloseCustomSnackbar = () => {
    this.setState({
      snackbarMessage: '',
      snackbarServerity: "success",
      snackbarOpen: false
    });
  };


  

  handleUserChange = (userContext: IUserContext) => {
    const apiKey = customPermissionApiKey.orderPermission;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForOrderPermissonStatus(apiKey, userData as PermissionGroupArray[]);
    const advancedSearchPermission = checkForAdvancedSearchPermissionStatus(userData as PermissionGroupArray[]);
    this.setState({ permissionStatus: value, advancedSearchPermissionStatus: advancedSearchPermission });
  };
  // Customizable Area End
}
